export type ExternalServiceType = 0 | 1 | 2;

interface IExternalServiceTypeEnum {
    Nugis: ExternalServiceType;
    Varis: ExternalServiceType;
    Medis: ExternalServiceType;
    format(value: number): string | undefined;
}

const datasource = [
    { key: 0, text: 'Nugis' },
    { key: 1, text: 'Varis' },
    { key: 2, text: 'Medis' }
];

export const ExternalServiceType: IExternalServiceTypeEnum = {
    Nugis: 0,
    Varis: 1,
    Medis: 2,
    format(value: number) {
        const item = datasource.find((x) => x.key === value);
        return item && item.text;
    }
};
